export default {
  selectedAnswerStatus: (state) => (answerStatusOptions) => {
    if (!state.segment?.rules.static.answer_status?.length) {
      return null;
    }
    const found = answerStatusOptions.find((status) => {
      return JSON.stringify(state.segment.rules.static.answer_status) == JSON.stringify(status?.value);
    });
    return found.value;
  }
};
